import React from "react";
import Preloader from "../helper/Preloader";
 import Breadcrumb from "../components/Breadcrumb";
 import BottomFooter from "../components/BottomFooter";
 import ScrollToTop from "react-scroll-to-top";
 import HeaderOneVendorStore from "../componentsAmazon/HeaderOneVendorStore";
import WishListSectionAmazon from "../componentsAmazon/WishListSectionAmazon";
import FooterOne from "../components/FooterOne";


const WishlistPageAmazon = () => {



  return (
    <>

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderOneVendorStore />

      {/* CartSection */}
      <WishListSectionAmazon />
 

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default WishlistPageAmazon;
